import { useChangeUnseenNotifications } from './useChangeUnseenNotifications';
import { RouteState, useNavigationStack } from '../context/NavigationStackContext';
import { IInAppNotification } from '../interface';

export const useNotificationRedirection = (onClose: () => void) => {
  const { push, clear } = useNavigationStack();
  const { mutate: changeUnseenNotifications } = useChangeUnseenNotifications();

  const redirect = (
    notification: IInAppNotification,
    config: { route: string; extraParams?: unknown },
  ) => {
    onClose();
    clear();
    changeUnseenNotifications({ ids: [notification?.id] });
    push(config.route + `/${notification?.data?.entityId}`, config.extraParams as RouteState);
  };

  return { redirect };
};
